import React from "react";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { AccordionActions } from "@material-ui/core";
import { Divider } from "@material-ui/core";
import clsx from "clsx";
import { FormControl } from "@material-ui/core";
import ApproachCheckbox from "../ScreenComponents/ApproachCheckbox.js";
import AddIcon from "@material-ui/icons/Add";
import RemoveIcon from "@material-ui/icons/Remove";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";

export default function ContractView(props) {
  const classes = props.classes;
  const recommendedContracts = props.recommendedContracts;
  const infoDict = props.infoDict;
  return (
    <>
      {recommendedContracts.map((elem) => (
        <Accordion
          key={recommendedContracts.indexOf(elem)}
          style={{ width: "100%" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-label="Expand"
            aria-controls="additional-actions1-content"
            id="additional-actions1-header"
          >
            <FormControl style={{ marginRight: 16 }}>
              <ApproachCheckbox
                checkedVal={props.currentContext.contractChoice[elem]}
                //nameVal={elem}
                approachVal={elem}
                handler={props.handler}
              />
            </FormControl>
            <div style={{ marginRight: 16 }}>
              <Typography className={classes.heading}>{elem}</Typography>
            </div>
            {/*
              <div className={classes.column}>
                <Typography className={classes.secondaryHeading}></Typography>
              </div>
              */}
          </AccordionSummary>
          <AccordionDetails className={classes.details}>
            <div className={classes.column}>
              <List dense>
                {infoDict[elem]["APPLICATION"].map((Application) => (
                  <ListItem
                    key={infoDict[elem]["APPLICATION"].indexOf(Application)}
                  >
                    <ListItemText primary={Application} />
                  </ListItem>
                ))}
              </List>
            </div>
            <div className={classes.column}>
              <List dense>
                {infoDict[elem]["BENEFITS"].map((Benefit) => (
                  <ListItem key={infoDict[elem]["BENEFITS"].indexOf(Benefit)}>
                    <ListItemIcon>
                      <AddIcon />
                    </ListItemIcon>
                    <ListItemText primary={Benefit} />
                  </ListItem>
                ))}
              </List>
            </div>
            <div className={clsx(classes.column)}>
              <List dense>
                {infoDict[elem]["LIMITATIONS"].map((downsides) => (
                  <ListItem
                    key={infoDict[elem]["LIMITATIONS"].indexOf(downsides)}
                  >
                    <ListItemIcon>
                      <RemoveIcon />
                    </ListItemIcon>
                    <ListItemText primary={downsides} />
                  </ListItem>
                ))}
              </List>
            </div>
          </AccordionDetails>
          <Divider />
          <AccordionActions>
            <Typography variant="caption">
              <List dense>
                {infoDict[elem]["Resources"].map((resources) => (
                  <ListItem
                    key={infoDict[elem]["Resources"].indexOf(resources)}
                  >
                    <ListItemText
                      secondary={
                        <a href={resources.split(": ")[1]} target="_blank>">
                          {resources.split(": ")[0]}
                        </a>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Typography>
          </AccordionActions>
        </Accordion>
      ))}
    </>
  );
}
